module.exports = __webpack_public_path__ + "static/news-list-bg-04ec46c0c8155365bfdb5ec14d8290de.svg";